if ($("#orderHistoryPage").length || $("#dashOrderHistory").length) {
    var $addFavForm = $("#frmFavoriteItem");
    var $removeFavForm = $("#frmUnfavoriteItem");
    var $nameField = $("#nameFavoriteOrder");
    var $emptyResult = "";
    var cartId = "";
    var isFirstRecentOrderApiCall = true;
    var orderInncr = 5;
    var spinnerHTML =
        "<div class='loader-container-small'><img class='order-history-spinner' src='" +
        spinner150 +
        "' alt='" +
        loadingText +
        "' /></div>";
    var nonSubwaySpinnerHTML =
        "<div class='loader-container-small'><img class='order-history-spinner' src='" +
        loadingImage +
        "' alt='" +
        loadingText +
        "' /></div>";

    if ($(".order-history-spinner").length) {
        var orderHistorySpinner = document.getElementsByClassName(
            "order-history-spinner"
        )[0];
        if ($("#dashOrderHistory").length) {
            orderHistorySpinner.src = loadingImage;
        } else {
            orderHistorySpinner.src = spinner150;
        }
        orderHistorySpinner.alt = loadingText;
    }
    var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
    // if storeId not found in cached client storage, try to retrieve from hidden field
    if (currentStore != 0) {
        if ($("#backLinkUrl").length) {
            var currentUrl = $("#backLinkUrl").attr("href");
            if (currentUrl.indexOf(currentStore) === -1) {
                var updatedUrl = currentUrl + "/restaurant/" + currentStore + "/menu";
                $("#backLinkUrl").attr("href", updatedUrl);
            }
        }
    }

    function locatorRedirect(locatorURL) {
        var id = window.orderViewModel.store.id;
        if (id !== null) {
            locatorURL = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
        }
        window.location.href = locatorURL;
    }

    var removeFavoriteHandler = function (itemContainer) {
        cartId = itemContainer[0].dataset["cartId"];
        var cartItemId = itemContainer[0].dataset["itemId"];
        $("#cartItemId", $removeFavForm).val(cartItemId);

        modalClose(false);
        modalShowId("#modal-remove-item");
    };

    var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
    // if storeId not found in cached client storage, try to retrieve from hidden field
    if (currentStore != 0) {
        if ($("#backLinkUrl").length) {
            var currentUrl = $("#backLinkUrl").attr("href");
            if (currentUrl.indexOf(currentStore) === -1) {
                var updatedUrl = currentUrl + "/restaurant/" + currentStore + "/menu";
                $("#backLinkUrl").attr("href", updatedUrl);
            }
        }
    }

    function locatorRedirect(locatorURL) {
        var id = window.orderViewModel.store.id;
        if (id !== null) {
            locatorURL = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
        }
        window.location.href = locatorURL;
    }

    var removeFavoriteHandler = function (itemContainer) {
        cartId = itemContainer[0].dataset["cartId"];
        var cartItemId = itemContainer[0].dataset["itemId"];
        $("#cartItemId", $removeFavForm).val(cartItemId);

        modalClose(false);
        modalShowId("#modal-remove-item");
    };

    var addFavoriteHandler = function (itemContainer) {
        var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
        cartId = itemContainer[0].dataset["cartId"];
        var productId = itemContainer[0].dataset["productId"];
        var orderedItem = itemContainer[0].dataset["orderitemId"];
        $("#favoriteProductId", $addFavForm).val(productId);
        $("#orderedItem", $addFavForm).val(orderedItem);
        $("#CartId", $addFavForm).val(cartId);
        modalClose(false);
        $(".fav-name-textbox").val("");
        $('.fav-character-count').text(60);
        modalShowId("#modal-favorite-item");
    };

    function loadHistoryItem(cartId, isAccordionOpen) {
        var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
        $("#OrderHistoryItemStoreId").val(currentStore);
        $("#OrderHistoryItemCartId").val(cartId);
        $("#" + cartId + " .order-history-spinner").attr("src", loadingImage);
        var $form = $("#frmOrderHistoryItem");
        var formStoreID = $("#OrderHistoryItemStoreId", $form).val();
        if (formStoreID == 0) {
            formStoreID = defaultFavoritesStoreId;
            $("#OrderHistoryItemStoreId", $form).val(formStoreID);
        }
        $("#hdnAccordionOpen", $form).val(isAccordionOpen);
        if ($("#dashOrderHistory").length) {
        }
        $.ajax({
            url: $form[0].action,
            type: "POST",
            data: $form.find("input[name!=IsRecentOrder]").serialize(),
            error: function (jqXhr) {
                subwayScript.showAjaxError(jqXhr);
            },
            success: function (htmlString) {
                var data = htmlString;
                if ($("#dashOrderHistory").length) {
                    //bind the all html data in the '$orderModal' model
                    var $orderModal = $("#orderDetails");
                    $orderModal.html(data);
                    var itemanavailable = $("#orderDetails").find("#item-unavailable").text();
                    analytics.Unavailabilty(itemanavailable);
                    var ingredientavailable = $("#orderDetails").find("#ingredient-available").text();
                    analytics.Unavailabilty(ingredientavailable);
                    var itemsubstitute = $("#orderDetails").find("#item-substitute").text();
                    analytics.Unavailabilty(itemsubstitute);
                    modalShowId("#orderDetails");
                    $("#orderDetails").show();
                }
                if ($("#orderHistoryPage").length) {
                    $("#" + cartId).html(data);
                    $(".icon-favorite").removeAttr("tabindex");
                    $(".icon-favorite").on("click keypress", function (e) {
                        if (e.which === keyCodes.RETURN || e.type === "click") {
                            var itemContainer = $(this).closest(".favorite-item-container");
                        }
                    });
                    $(".icon-favorite_border").on("click keypress", function (e) {
                        if (e.which === keyCodes.RETURN || e.type === "click") {
                            var itemContainer = $(this).closest(".favorite-item-container");
                            addFavoriteHandler(itemContainer);
                        }
                    });
                }
                if ($("#orderDetails").length) {
                    $(".modal-item-data").each(function () {
                        if ($(".modal-item-data").length > 2) {
                            recentModalItem();
                            return false;
                        } else {
                            $(".modal-item").removeClass("active").next().attr("style", "");
                            $(".model-order-from").css({ display: "none", cursor: "auto" });
                            $(".modal-item").css({ cursor: "auto" });
                        }
                    });
                }
                if ($('#item-available').val() === 'False') {
                    var StoreId = subwayScript.checkSatelliteNumber($('#item-storeid').val());

                    $('#recent-item-unavailable-back-to-menu').click(function () {
                        window.location.href = subwayScript.navigation.getMenuUrl(StoreId);
                    });
                }
            },
        });
    }

    function addToBag(ohDataItemId, ohCartItemId, ohProductId, ohPrice) {
        if (!orderViewModel.store || !orderViewModel.store.id) {
            subwayScript.showLocationRequiredModal();
            return;
        }
        var cartItemId = ohDataItemId;
        var cartId = ohCartItemId;
        var productId = ohProductId;
        var price = ohPrice;
        var currentCart = orderViewModel.currentOrder.cartId;

        if (
            cartItemId &&
            cartId &&
            orderViewModel.store &&
            orderViewModel.store.id
        ) {
            var $reorderForm = $("#frmReorderItemCart");

            $('[name="StoreId"]', $reorderForm).val(orderViewModel.store.id);
            $('[name="ReorderedItemCartId"]', $reorderForm).val(cartId);
            $('[name="ReorderedItemCartItemId"]', $reorderForm).val(cartItemId);
            $('[name="CurrentOrderCartId"]', $reorderForm).val(currentCart);

            $.ajax({
                url: $reorderForm.attr("action"),
                type: "POST",
                data: $reorderForm.serialize(),
                success: function (data) {
                    var addToBagSource = subwayScript.isDashboard()
                        ? analytics.addToBagSources.recentOrderHome
                        : analytics.addToBagSources.recentOrderSubPage;
                    orderViewModel.currentOrder.itemAddedtoBag = 0;
                    orderViewModel.save();
                    analytics.addItemToBag("", productId, price, 1, addToBagSource, data.CartQuantity);
                    var orderCartId = data.CartId;
                    var orderQuantity = data.CartQuantity;

                    orderViewModel.currentOrder.cartId = orderCartId;
                    orderViewModel.currentOrder.cartQuantity = orderQuantity;
                    orderViewModel.addCartProducts(data.CartItemId, data.ProductID, data.CategoryId, '');
                    orderViewModel.save();

                    window.location.href = data.successUrl;
                },
                error: function (jqXhr) {
                    modalClose(true);

                    subwayScript.showAjaxError(jqXhr);
                },
            });
        }
    }

    // onclick of model recent order accordian expand and collapse in the popup
    function recentModalItem() {
        $(".modal-item").on("click keypress", function (e) {
            if (!$(this).hasClass("active")) {
                $(this).addClass("active").next().slideDown(200);
                $(".model-order-from").attr("style", "");
            } else {
                $(this).removeClass("active").next().slideUp(200);
            }
        });
        $(".fa-heart, .fa-heart-o").click(function (e) {
            e.stopPropagation();
        });
        // Target first child
        $(".modal-item-data").each(function () {
            $(this)
                .first()
                .find(".modal-item")
                .addClass("active")
                .next()
                .slideDown(0);
            return false;
        });
    }

    // onload mobile view home page accordian
    function onloadHomeAccoridan() {
        if ($(window).width() < 1024) {
            if ($(".panel-collapse").length > 0) {
                if ($(".panel-collapse").hasClass("in")) {
                    $(".panel-collapse").each(function () {
                        $(".panel-data").attr("style", "");
                        $(this).css("display", "none").addClass("collapse");
                        $(this)
                            .parent(".panel")
                            .find(".panel-title a")
                            .addClass("collapsed");
                    });
                }
            }
        } else {
            var accordionState = $("#dashOrderHistory").data("accordion-state");
            $(".panel-collapse").each(function () {
                if (accordionState === true) {
                    $(this).addClass("in").css("display", "block");
                    $(this)
                        .parent(".panel")
                        .find(".panel-title a")
                        .removeClass("collapsed");
                } else {
                    $(this).removeClass("in").css("display", "none");
                    $(this).parent(".panel").find(".panel-title a").addClass("collapsed");
                }
            });
            dashEvenGridPanels();
        }
    }

    function dashEvenGridPanels() {
        $.when($(document).ready).then(function () {
            $(".panel-data").each(function () {
                $(this).css("height", ""); // clear height values
            });
            var heights = []; // make an array
            $(".panel-data").each(function () {
                // copy the height of each
                heights.push($(this).height()); //   element to the array
            });
            heights.sort(function (a, b) {
                return b - a;
            }); // sort the array high to low
            var minh = heights[0]; // take the highest number

            if ($(window).width() < 1024) {
                $(".panel-data").attr("style", "");
            } else {
                if (minh >= 0) $(".panel-data").height(minh); // and apply that to each element
            }
        });
    }

    function showMoreOrders() {
        var $orders = $("#orderHistoryPage .item-ordered");
        var ordersShown = $orders.filter(":visible").length;
        var data = $(".item-ordered").length;
        var i;
        var j = ordersShown;

        for (
            i = ordersShown;
            i < Math.min($orders.length, ordersShown + orderInncr);
            i++
        ) {
            $($orders[i]).show();
        }

        if (ordersShown + orderInncr < data) {
            $("#orderHistoryPage .show-more").show();
        } else $("#orderHistoryPage .show-more").hide();
        if (j !== 0 || j >= orderInncr) {
            var accordian = $(".accordion-title", "#orderHistoryPage");
            $(accordian)[j].focus();
        }
    }

    function dashRecentOrder() {
        var $form = $("#frmOrderHistory");
        var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;

        $("#initStoreId").val(currentStore);
        $.ajax({
            url: $form[0].action,
            type: "POST",
            data: $form.serialize(),
            dataType: "html",
            error: function (jqXhr) {
                subwayScript.showAjaxError(jqXhr);

                if ($("#dashOrderHistory").length) {
                    // show error message
                    $(".api-error").attr("style", "");
                    //hide spinner img
                }

                if ($("#orderHistoryPage").length) {
                    $(".api-error-container").show();
                }
            },
            success: function (html) {
                var dom = $.parseHTML(html, true);
                $("#historyResults").html(dom);

                if (
                    parseInt(
                        $("#hdnNoOfItemsToShowDashOH").attr("data-order-history-count")
                    ) > parseInt($("#hdnNoOfItemsToShowDashOH").val())
                ) {
                    if ($(".no-order-item-text").length) {
                        $(".view-all-orders").css("display", "none");
                    } else {
                        $(".view-all-orders").css("display", "block");
                    }
                    isFirstRecentOrderApiCall = false;
                }

                if (hideReorder != "false") {
                    $('#historyResults').hide();
                    $('.view-all-orders').css('display', 'none');
                    $('.show-more').hide();
                    $('.hide-order-message').show();
                }

                if (disableReorder != "false") {
                    $(".creorder").hide();
                }

                if (orderViewModel.store.StoreId && orderViewModel.currentOrder.cartId && orderViewModel.addToBagPayLoadItem && orderViewModel.addToBagPayLoadItem.paylaod && orderViewModel.addToBagPayLoadItem.analyticsProductArr) {
                    var cartID = orderViewModel.RecentOrderCartID;
                    var paylaod = orderViewModel.addToBagPayLoadItem.paylaod;
                    var analyticsProductArr = orderViewModel.addToBagPayLoadItem.analyticsProductArr;
                    var productId = paylaod.items.AddCartItems[0].productId;
                    paylaod.CartId = orderViewModel.currentOrder.cartId;
                    paylaod.LocationId = orderViewModel.store.StoreId;
                    paylaod.StoreId = orderViewModel.store.StoreId;
                    AddItemAsync(cartID, productId, paylaod, analyticsProductArr);
                }

                if ($("#orderHistoryPage").length) {
                    if ($("li", $("#historyResults")).length) {
                        $emptyResult.hide();
                        showMoreOrders();
                        loadHistoryItem($(".recent-order-ul li:first .order-container .accordion-title").attr("cartId"), false);
                        $(
                            ".recent-order-ul li:first .order-container .accordion-title"
                        ).addClass("is-expanded");
                        $(
                            ".recent-order-ul li:first .order-container .accordion-title"
                        ).attr("aria-expanded", true);
                        $(".recent-order-ul li:first .accordion-content").removeClass(
                            "is-collapsed"
                        );
                        $(".recent-order-ul li:first .accordion-content").addClass(
                            "is-expanded"
                        );
                        $(".recent-order-ul li:first .accordion-content").attr(
                            "aria-hidden",
                            "false"
                        );
                    } else {
                        $emptyResult.show();
                        $("#recent-order-disclaimer").hide();
                    }

                    $addFavForm = $("#frmFavoriteItem");
                    $removeFavForm = $("#frmUnfavoriteItem");
                    $nameField = $("#nameFavoriteOrder");

                    $("#saveAddFavorite").click(function () {
                        var favoriteName = $nameField.val();

                        if (!favoriteName) {
                            return false;
                        }
                        subwayScript.showSpinner();
                        $("#Name", $addFavForm).val(favoriteName);

                        $.ajax({
                            url: $addFavForm.attr("action"),
                            type: "POST",
                            data: $addFavForm.serialize(),
                            error: function (jqXhr) {
                                let parentCode = 'n/a';
                                let childCode = 'n/a';
                                subwayScript.hideSpinner();
                                modalClose(true);
                                modalShowId("#fav-max-limit-modal");
                                if (jqXhr.responseJSON && jqXhr.responseJSON.Error && jqXhr.responseJSON.Error.ErrorCode) {
                                    parentCode = jqXhr.responseJSON.Error.ParentCode ? jqXhr.responseJSON.Error.ParentCode : 'n/a';
                                    childCode = jqXhr.responseJSON.Error.ErrorCode

                                }
                                const errMsg = $('#fav-max-limit-modal .fav-modal-title').text().trim() || ''
                                analytics.errorMessage(errMsg, parentCode, childCode, true)
                            },
                            success: function (data) {
                                subwayScript.hideSpinner();
                                var item = $("#CartItemId", $addFavForm);
                                var productId = $("#favoriteProductId", $addFavForm).val();

                                analytics.favoriteItem(productId);

                                if (item.length > 0) {
                                    var $itemListing = $('[data-item-id="' + item.val() + '"]');
                                    var $iconElement = $(".icon-favorite", $itemListing);

                                    $iconElement.off("click");
                                    $iconElement.click(removeFavoriteHandler);

                                    // hide the item description for when it's not a favorite, show the item description when it is a fav
                                    var $favDescription = $(
                                        ".favorite-description",
                                        $itemListing
                                    );
                                    var $noFavDescription = $(
                                        ".no-favorite-description",
                                        $itemListing
                                    );

                                    $favDescription.show();
                                    $noFavDescription.hide();
                                }
                                loadHistoryItem(cartId, false);
                                modalClose(true);
                                $("#" + cartId).html(nonSubwaySpinnerHTML);
                                $("html, body").animate({ scrollTop: 0 }, "slow");
                                $("#showHideMsg").show();
                                setTimeout(function () {
                                    $("#showHideMsg").hide();
                                }, 5000);
                                $nameField.val("");
                            },
                        });
                        return true;
                    });

                    $('.fav-name-textbox').on('click keyup change', function () {
                        var instructionValue = $(this).val();
                        var maxLength = parseInt($(this).attr('maxlength') || 60);
                        if (instructionValue.length > maxLength) {
                            instructionValue = instructionValue.substring(0, maxLength);
                            $(this).val(instructionValue);
                        }
                        $('.fav-character-count').text(maxLength - instructionValue.length);
                        if ($(this).val().trim()) {
                            $('#saveAddFavorite').removeClass('disabled')
                        } else {
                            $('#saveAddFavorite').addClass('disabled')
                        }
                    });

                    $("#removeFavoriteItem").click(function () {
                        $.ajax({
                            url: $removeFavForm.attr("action"),
                            type: "POST",
                            data: $removeFavForm.serialize(),
                            error: function (jqXhr) {
                                modalClose(true);
                                subwayScript.showAjaxError(jqXhr);
                            },
                            success: function () {
                                var item = $("#cartItemId", $removeFavForm);

                                if (item.length > 0) {
                                    var $itemListing = $('[data-item-id="' + item.val() + '"]');
                                    var $iconElement = $(".icon-favorite_border", $itemListing);

                                    $iconElement.off("click");
                                    $iconElement.click(addFavoriteHandler);

                                    // hide the item description for when it's not a favorite, show the item description when it is a fav
                                    var $favDescription = $(
                                        ".favorite-description",
                                        $itemListing
                                    );
                                    var $noFavDescription = $(
                                        ".no-favorite-description",
                                        $itemListing
                                    );

                                    $favDescription.hide();
                                    $noFavDescription.show();
                                }
                                loadHistoryItem(cartId, false);
                                $("#" + cartId).html(spinnerHTML);
                                modalClose(true);
                            },
                        });
                    });
                    $(".accordion-title").on("click keypress", function (e) {
                        if (e.which === keyCodes.RETURN || e.type === "click") {
                            if (
                                $(this)
                                    .closest(".accordionTitle")
                                    .next(".accordion-content")
                                    .hasClass("is-collapsed")
                            ) {
                                $("#initModal").attr("value", "false");
                                loadHistoryItem($(this).attr("cartId"), false);
                                $(this).addClass("is-expanded").removeClass("is-collapsed");
                                $(this)
                                    .closest(".accordionTitle")
                                    .next(".accordion-content")
                                    .addClass("is-expanded")
                                    .removeClass("is-collapsed");
                                $(this)
                                    .parent()
                                    .find(".outside-controls")
                                    .addClass("hide-remove");
                                $(this).attr("aria-expanded", true);
                                $(this)
                                    .closest(".accordionTitle")
                                    .next(".accordion-content")
                                    .attr("aria-hidden", false);
                                analytics.expandCollapse('recent order', 'location expand arrow')
                            } else {
                                $(this)
                                    .parent()
                                    .find(".outside-controls")
                                    .removeClass("hide-remove");
                                $(this).addClass("is-collapsed").removeClass("is-expanded");
                                $(this)
                                    .closest(".accordionTitle")
                                    .next(".accordion-content")
                                    .addClass("is-collapsed")
                                    .removeClass("is-expanded");
                                $(this).attr("aria-expanded", false);
                                $(this)
                                    .closest(".accordionTitle")
                                    .next(".accordion-content")
                                    .attr("aria-hidden", true);
                                analytics.expandCollapse('recent order', 'location collapse arrow')
                            }
                        }
                    });
                } else {
                }
            },
        }).done(function () {
            $('.errorbody').hide()
        });
    }
}

$(document).ready(function () {
    if ($("#orderHistoryPage").length || $("#dashOrderHistory").length) {
        (function () {
            $emptyResult = $(".order-history .no-orders, .order-history .start-order");
            $emptyResult.hide();

            var $startOrder = $("#btnStartOrder");
            var startOrderUrl;

            if (orderViewModel.store && orderViewModel.store.id && orderViewModel.orderType === 'delivery') {
                startOrderUrl = subwayScript.navigation.getMenuUrl(
                    orderViewModel.store.id
                );
            } else {
                startOrderUrl = subwayScript.navigation.getLocatorUrl();
            }

            $startOrder.attr("href", startOrderUrl);

            var accordionState = $("#dashOrderHistory").data("accordion-state");

            if ($("#dashOrderHistory").length) {
                // check,if the home page accodion is expandable and collapse
                if (accordionState === true) {
                    dashRecentOrder();
                }
            } else {
                dashRecentOrder();
            }

            // onload adding .home-accordian class
            $(".grid-panel-component")
                .closest(".col-sm-6")
                .parent(".row")
                .addClass("home-accordian");

            var disable_click_flag = false;

            $(window).scroll(function () {
                disable_click_flag = true;

                clearTimeout($.data(this, "scrollTimer"));

                $.data(
                    this,
                    "scrollTimer",
                    setTimeout(function () {
                        disable_click_flag = false;
                    }, 250)
                );
            });

            $("body").on("click", ".panel-heading", function (e) {
                if (disable_click_flag) {
                    e.preventDefault();
                }
            });

            // onclick of home page accordian
            $(document).on("click", ".panel-heading", function () {
                if ($(window).width() > 1023) {
                    var isParentRowCls = $(this).closest(".home-accordian");
                    var isFindAccordianCls = isParentRowCls.find(".panel-collapse");
                    var isPanelHeadingAncher = $(this).children("h4").find("a");

                    $(isFindAccordianCls).each(function () {
                        if ($(this).hasClass("in")) {
                            $(this).slideUp("fast");
                            $(this).removeClass("in");
                        } else {
                            $(this).addClass("in");
                            $(this).slideDown("fast");
                        }
                    });
                    getPanelTitle(isPanelHeadingAncher);
                    dashEvenGridPanels();
                    if (isFirstRecentOrderApiCall !== false) {
                        dashMyFavorite();
                        dashRecentOrder();
                    }
                } else {
                    var isParentClass = $(this).parent(".panel").find(".panel-collapse");
                    if (isParentClass.hasClass("collapse")) {
                        $(isParentClass).slideDown("fast").removeClass("collapse");
                        $(isParentClass)
                            .parent(".panel")
                            .find(".panel-heading h4 a")
                            .removeClass("collapsed");
                    } else {
                        $(isParentClass).slideUp("fast").addClass("collapse");
                        $(isParentClass)
                            .parent(".panel")
                            .find(".panel-heading h4 a")
                            .addClass("collapsed");
                    }
                }
            });
            function getPanelTitle(isPanelHeading) {
                var getTitleContainer = $(isPanelHeading)
                    .closest(".home-accordian")
                    .find(".panel-title a");
                $(getTitleContainer).each(function () {
                    if ($(getTitleContainer).hasClass("collapsed")) {
                        $(getTitleContainer).removeClass("collapsed");
                        $(getTitleContainer).attr("aria-expanded", true);
                        return false;
                    } else {
                        $(getTitleContainer).addClass("collapsed");
                        $(getTitleContainer).attr("aria-expanded", false);
                        return false;
                    }
                });
            }
            dashEvenGridPanels();
            onloadHomeAccoridan();
            $(window).on("resize", function () {
                onloadHomeAccoridan();
                dashEvenGridPanels();
            });
        })();
    }
    $("#btnStartOrder").on('click', function () {
        fwhtrk.page.link = fwhtrk.page.section + "|" + "start an order now";
        fwhtrk.event.startonlineorder = 1;
        analytics.attemptTrack("account_click_action");
    });
})

function getRecentOrderDetails(e) {
    const $targetElement = event.target;
    const recent_order_container = $($targetElement.closest(".accordion-content")).find(".cart-item-container");
    const recentOrderItemsArr = [];
    const single_items = recent_order_container.children();

    for (i = 0; i < single_items.length; i++) {
        const firstChildElement = $(single_items[i]).find(".title-container");
        let product_id = "",
            price = "",
            quantity = "",
            analytics_product_id = "",
            analytics_category_name = "",
            analytics_category_id = "",
            analytics_product_name = "",
            analytics_product_name_size='',
            analytics_in_stock = "",
            options = null,
            combo = null;
        for (j = 0; j < $(single_items[i]).children().length; j++) {
            if (single_items[i].children[j].getAttribute("class").includes("details-container")) {
                combo = JSON.parse(single_items[i].children[j].getAttribute("data-item-miam"));
                options = JSON.parse(single_items[i].children[j].getAttribute("data-item-options"));
            }
        }
        product_id = firstChildElement.attr("data-analytics-product-name");
        quantity = firstChildElement.attr("data-quantity");
        analytics_product_id = firstChildElement.attr("data-product-id");
        analytics_category_name = firstChildElement.attr("data-category-name");
        analytics_product_name = firstChildElement.attr("data-analytics-product-id");
        analytics_product_name_size = firstChildElement.attr("data-analytics-product-name");
        analytics_in_stock = firstChildElement.attr("data-analytics-instock");
        const out_of_stock_price = parseFloat(getOutOfStockItemsPrice(options)) * quantity;
        options = filterOutOfStockItems(options);
        price = parseFloat(firstChildElement.attr("data-item-price")) - out_of_stock_price;

        let recentOrderSingleItem = {
            "ProductId": product_id,
            "Price": price,
            "Quantity": quantity,
            "AnalyticsProductId": analytics_product_id,
            "AnalyticsCategoryName": analytics_category_name,
            "AnalyticsCategoryId": analytics_category_id,
            "AnalyticsProductName": analytics_product_name,
            "ProductNameWithSize": analytics_product_name_size,
            "AnalyticsInStock": analytics_in_stock,
            "Options": options,
            "Combo": combo
        }
        recentOrderItemsArr.push(recentOrderSingleItem);
    }
    return recentOrderItemsArr;
};

const filterOutOfStockItems = options => {
    let filtered_arr = null;
    if (options) {
        filtered_arr = options.filter(item => item.available == true || item.available == "true");
    }
    return filtered_arr;
};

const getOutOfStockItemsPrice = options => {
    let items_price = 0;
    if (options) {
        options.forEach(item => {
            if(item.available == false || item.available == "false"){
                items_price =  items_price + item.price
            }
        });
    }
    return items_price;
};

function OrderHistoryStoreValidationAsync(event, el, recentOrdersCartId, reOrderbtn, recentOrderPopup = null, recentOrderItems) {
    var cartID, storeId, orderType = "";
    var mergeCart = false;
    var siteName = $('#hdnSiteName').val()
    cartID = recentOrdersCartId;
    if (Number(orderViewModel.currentOrder.cartQuantity) > 0) {
        mergeCart = true;
    }
    if (el) {
        var order = $(el).closest(".lo-order-cart");
        if (orderViewModel.currentOrder.cartQuantity === 0) {
            storeId = subwayScript.checkSatelliteNumber(order.data("storeid"));
            orderType = order.data("ordertype") ? order.data("ordertype").toLowerCase() : '';
        } else {
            storeId = orderViewModel.store.StoreId;
            orderType = orderViewModel.orderType;
        }
    } else {
        var order = $(el).closest(".lo-order-cart");
        if (orderViewModel.currentOrder.cartQuantity === 0) {
            storeId = subwayScript.checkSatelliteNumber(event.target.getAttribute('data-storeid')) || orderViewModel.store.StoreId;
            orderType = event.target.getAttribute('data-fulfilment') || orderViewModel.orderType;
        } else {
            storeId = orderViewModel.store.id;
            orderType = orderViewModel.orderType;
        }
    }
    orderViewModel.IsRecentOrder = true;
    orderViewModel.save();
    if (recentOrderPopup) {
        orderViewModel.IsRecentOrder = false;
        orderViewModel.save();
    }

    if (orderType == 'delivery' || orderType == 'Delivery') {
        if (mergeCart) {
            var data = {
                CartId: cartID,
                StoreId: storeId,
                OrderType: orderType,
                IsRecentOrder: orderViewModel.IsRecentOrder,
                IsAccordionOpen: false,
                IsModalView: true,
                MergeCart: mergeCart,
                StreetAddressLine1: orderViewModel.DeliveryAddress.StreetAddressLine1,
                StreetAddressLine2: '',
                City: orderViewModel.DeliveryAddress.City,
                State: orderViewModel.DeliveryAddress.State,
                Zip: orderViewModel.DeliveryAddress.Zip,
                Country: orderViewModel.DeliveryAddress.Country,
                SiteName: siteName
            };
        } else {
            var data = {
                CartId: cartID,
                StoreId: storeId,
                OrderType: orderType,
                IsRecentOrder: orderViewModel.IsRecentOrder,
                IsAccordionOpen: false,
                IsModalView: true,
                MergeCart: mergeCart,
                SiteName: siteName
            };
        }
    } else {
        var data = {
            CartId: cartID,
            StoreId: storeId,
            OrderType: orderType,
            MergeCart: mergeCart,
            SiteName: siteName
        };
    }

    var $form = $("#frmOrderHistoryStoreValidationAsync");
    subwayScript.showSpinner();
    // async: false, commented because spinner not working
    $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        cache: false,
        headers: { "cache-control": "no-cache" },
        data: data,
        error: function (jqXhr) {
            if (el) {
                let buttonText = $(el).text().trim();
                analytics.lastorderReorder(buttonText, orderViewModel.OrderSourceType);
            }
            if (jqXhr.responseJSON && (jqXhr.responseJSON.Error.ErrorCode.toLowerCase() == 'dord-3006' || jqXhr.responseJSON.Error.ErrorCode.toLowerCase() == 'ordr-3000')) {
                modalShowId('#modal-store-closed');
            }
            else {
                subwayScript.showAjaxError(jqXhr);
            }
            subwayScript.hideSpinner();
        },
        success: function (resultData) {
            if (resultData.Error) {
                if (orderType == "delivery") {
                    $("#modal-title").text(resultData.Error.Title);
                    $("#modal-body").text(resultData.Error.Message);
                    $("#modalDeliveryError").show();
                    $("#modalDeliveryError").attr("data-cart-id", cartID);
                    modalShowId("#modalDeliveryError");
                } else {
                    subwayScript.showAjaxError(resultData);
                }
            }
            var $lastOrderModal = $("#lastOrderModal");
            $lastOrderModal.html(resultData);
            $("#lastOrderReOrderModal").show();
            modalShowId("#lastOrderReOrderModal");
            //resultData.Isdelivery     //orderType:delivery
            if (orderType == "delivery" && !resultData.Error) {
                var productAvailable = resultData.itemavailable;
                var ingredientsAvailable = resultData.ingredientavailable;
                var SuccessResult = resultData.SuccessResult;

                if (SuccessResult) {
                    orderViewModel.store.id = SuccessResult.PickupLocationId;
                    orderViewModel.DeliveryAddress.StreetAddressLine1 = SuccessResult.DeliveryAddress.StreetAddressLine1;
                    orderViewModel.DeliveryAddress.StreetAddressLine2 = SuccessResult.DeliveryAddress.StreetAddressLine2;
                    orderViewModel.DeliveryAddress.City = SuccessResult.DeliveryAddress.City;
                    orderViewModel.DeliveryAddress.State = SuccessResult.DeliveryAddress.State;
                    orderViewModel.DeliveryAddress.Zip = SuccessResult.DeliveryAddress.Zip;
                    orderViewModel.DeliveryAddress.Country = SuccessResult.DeliveryAddress.Country;
                    orderViewModel.DeliveryAddress.DirectDelivery = true;
                    orderViewModel.DeliveryAddress.QuoteId = SuccessResult.QuoteId;
                    orderViewModel.save();
                }

                if (productAvailable && ingredientsAvailable) {
                    ReOrderCart(cartID, true, false, null, orderType);
                }

                if (productAvailable === false || ingredientsAvailable === false) {
                    $("#lastOrderReOrderModal").show();
                    modalShowId("#lastOrderReOrderModal");
                    OrderHistoryStoreValidationAsync(event, null, recentOrdersCartId, reOrderbtn, "recentOrderPopup");
                }
                if (Number(orderViewModel.currentOrder.cartQuantity) > 0) {
                    $('#MergeCartHide').hide();
                    $('#MergeCartShow').show();
                }

                if (
                    orderViewModel.store.id != null &&
                    orderViewModel.currentOrder.cartQuantity != 0 &&
                    $("#reorder-change-store").attr("aria-hidden") != "false"
                ) {
                    $("#btnReorderItem").on("click keypress", function (e) {
                        orderViewModel.orderType = "delivery";
                        orderViewModel.AnalyticsorderType = "Delivery";
                        orderViewModel.RecentOrdersCartID = cartID;
                        orderViewModel.currentOrder.cartQuantity = 0;
                        orderViewModel.save();
                        ReOrderCart(cartId, true, null, null);
                    });
                    const errMsg = $('#reorder-change-store .error-body').text() || ''
                    if (el) {
                        let buttonText = $(el).text().trim();
                        analytics.lastorderReorder(buttonText, orderViewModel.OrderSourceType);
                    }
                    analytics.errorMessage(errMsg, 'n/a', 'n/a', false)
                    return;
                }
                orderViewModel.orderType = "delivery";
                orderViewModel.AnalyticsorderType = "Delivery";
                orderViewModel.RecentOrdersCartID = cartID;
                orderViewModel.save();
            } else if (resultData.IsStoreOpen == false) {
                // IsStoreOpen is false, may be stores where local POS is offline or is unsupportive of checkout.
                if (orderType !== "delivery") {
                    modalShowId('#modal-store-closed');
                }
                const errMsg = $('#modal-store-closed .body-txt').text() || '';
                analytics.errorMessage(errMsg, 'n/a', 'n/a', false)
            } else if (resultData.IsWebOrderAvailable == false) {
                modalShowId('#modal-web-order-not-available');
                const errMsg = $('#modal-web-order-not-available .error-body').text() || '';
                analytics.errorMessage(errMsg, 'n/a', 'n/a', false)
            } else {
                if (orderViewModel.RecentOrdersCartID !== null) {
                    orderViewModel.RecentOrdersCartID = null;
                    orderViewModel.save();
                }
                orderViewModel.RecentOrdersCartID = cartID;
                if (resultData.OrderType === "pickup") {
                    orderViewModel.orderType = "pickup";
                    orderViewModel.AnalyticsorderType = "In-Store Pickup";
                    if (el) {
                        lastorderReorderModal(el, null, reOrderbtn);
                    } else {
                        lastorderReorderModal(null, cartID, reOrderbtn, recentOrderItems);
                    }
                } else if (resultData.HasCurbside === false && resultData.OrderType === "curbside") {
                    orderViewModel.lastOrderData = el;
                    modalShowId('#curbside-un-available-store-popup');
                    $(".street-Address-1").text(resultData.StreetAddress1);
                    $(".city-State-Country").text(resultData.CityStateCountry);
                } else if (resultData.HasCurbsideAfterHours === true || resultData.CurbSideLastCall === true) {
                    orderViewModel.lastOrderData = el;
                    $(".curbsidetext").text(resultData.CurbsideNotAvailableMsg);
                    $("#schedule-later-pickup").hide();
                    $("#in-store-pickup").css("margin", "auto");
                    $("#in-store-pickup").css("float", "none");
                    $(".street-Address-1").text(resultData.StreetAddress1);
                    $(".city-State-Country").text(resultData.CityStateCountry);
                    return false;
                } else if (resultData.HasCurbsideBeforeHours !== true && resultData.HasCurbside === true) {
                    orderViewModel.orderType = "curbside";
                    orderViewModel.AnalyticsorderType = "Curbside Pickup";
                    if (el) {
                        lastorderReorderModal(el, null, reOrderbtn);
                    } else {
                        lastorderReorderModal(null, cartID, reOrderbtn);
                    }
                } else if (resultData.HasCurbsideBeforeHours === true && resultData.HasCurbside === true) {
                    orderViewModel.lastOrderData = el;
                    orderViewModel.orderType = "curbside";
                    orderViewModel.AnalyticsorderType = "Curbside Pickup";
                    $(".curbsidetext").text(resultData.CurbsideAvailableMessage);
                    $("#schedule-later-pickup").text(resultData.ScheduleLaterPickup);
                    $(".street-Address-1").text(resultData.StreetAddress1);
                    $(".city-State-Country").text(resultData.CityStateCountry);
                    return false;
                }
            }
        }
    });
}
function loadReorderModal(cartId) {
    subwayScript.showSpinner();
    var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
    $("#OrderHistoryItemStoreId").val(currentStore);
    $("#OrderHistoryItemCartId").val(cartId);
    $("#" + cartId + " .order-history-spinner").attr("src", loadingImage);
    var $form = $("#frmOrderHistoryItem");
    var formStoreID = $("#OrderHistoryItemStoreId", $form).val();
    if (formStoreID == 0) {
        //formStoreID = defaultFavoritesStoreId;
        $("#OrderHistoryItemStoreId", $form).val(formStoreID);
    }
    $("#hdnAccordionOpen", $form).val(false);
    $.ajax({
        url: $form[0].action,
        type: "POST",
        data: $form.serialize(),
        error: function (jqXhr) {
            subwayScript.showAjaxError(jqXhr);
            subwayScript.hideSpinner();
        },
        success: function (htmlString) {
            var data = htmlString;
            subwayScript.hideSpinner();
            //bind the all html data in the '$orderModal' model
            var $orderModal = $("#orderDetails");
            $orderModal.html(data);
            modalClose(true);
            modalShowId("#orderDetails");
            $("#orderDetails").show();
            if ($("#orderDetails").length) {
                $(".modal-item-data").each(function () {
                    if ($(".modal-item-data").length > 2) {
                        recentModalItem();
                        return false;
                    } else {
                        $(".modal-item").removeClass("active").next().attr("style", "");
                        $(".model-order-from").css({ display: "none", cursor: "auto" });
                        $(".modal-item").css({ cursor: "auto" });
                    }
                });
            }
        },
    });
}
var isReorder = false;
function ReOrderCart(cartId, skipStoreRequired, IsAddToBag, ProductId, orderType, reOrderbtn, recentOrderItems,fromOrderAgain) {
    var currentOrderType = orderViewModel.orderType || orderType;
    var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
    orderViewModel.OrderSourceType = fromOrderAgain
      ? analytics.orderSourceType.reorder
      : analytics.orderSourceType.recentOrderCart;
    analytics.OrderSourceType(orderViewModel.OrderSourceType);
    var isCombo = recentOrderItems[0].Combo && Object.keys(recentOrderItems[0].Combo).length !== 0;
    var mergeCart = false;
    if (Number(orderViewModel.currentOrder.cartQuantity) > 0) {
        mergeCart = true;
        mergeCartID = orderViewModel.currentOrder.cartId;
    }

    $("#btnReorderItem").on("click keypress", function (e) {
        isReorder = true;
        ReOrderCart(cartId, true, true, null);
    });
    if (
        orderViewModel.store.id != null &&
        orderViewModel.currentOrder.cartQuantity != 0 && !IsAddToBag && !mergeCart
    ) {
        if ($("#orderDetails").attr("aria-hidden") != "true") {
            $("#orderDetails").hide();
        }

        const errMsg = $('#reorder-change-store .error-body').text() || ''
        analytics.errorMessage(errMsg, 'n/a', 'n/a', false)

        return;
    }
    if (
        skipStoreRequired === true ||
        (orderViewModel.store && orderViewModel.store.id)
    ) {
        var $reorderForm = $("#frmReorderCart");
        if (cartId) {
            $('[name="CartId"]', $reorderForm).val(cartId);
            $('[name="CurrentCartId"]', $reorderForm).val(orderViewModel.currentOrder.cartId);
            if (Number(orderViewModel.currentOrder.cartQuantity) > 0) {
                $('[name="OrderId"]', $reorderForm).val(orderViewModel.currentOrder.cartId);
            }
        }
        if (isReorder) {
            IsAddToBag = false;
            $('[name="OrderId"]', $reorderForm).val('');
            $('[name="CurrentCartId"]', $reorderForm).val('');
        }
        $('[name="IsAddToBag"]', $reorderForm).val(IsAddToBag);
        if (ProductId) {
            $('[name="ProductId"]', $reorderForm).val(ProductId);
        }
        if (mergeCart) {
            $('[name="MergeCart"]', $reorderForm).val(true);
            $('[name="MergeCartId"]', $reorderForm).val(mergeCartID);
        }
        $('[name="StoreId"]', $reorderForm).val(currentStore);
        $('[name="StreetAddressLine1"]', $reorderForm).val(orderViewModel.DeliveryAddress.StreetAddressLine1);
        $('[name="StreetAddressLine2"]', $reorderForm).val(orderViewModel.DeliveryAddress.StreetAddressLine2);
        $('[name="City"]', $reorderForm).val(orderViewModel.DeliveryAddress.City);
        $('[name="State"]', $reorderForm).val(orderViewModel.DeliveryAddress.State);
        $('[name="Zip"]', $reorderForm).val(orderViewModel.DeliveryAddress.Zip);
        $('[name="Country"]', $reorderForm).val(orderViewModel.DeliveryAddress.Country);
        $('[name="DirectDelivery"]', $reorderForm).val(orderViewModel.DeliveryAddress.DirectDelivery);
        $('[name="QuoteId"]', $reorderForm).val(orderViewModel.DeliveryAddress.QuoteId);
        $('[name="OrderType"]', $reorderForm).val(currentOrderType);
        $('[name="OrderSourceType"]', $reorderForm).val(analytics.orderSourceType.recentOrderCart);
        $('[name="ComboOriginSource"]', $reorderForm).val(isCombo ? orderViewModel.OrderSourceType :'n/a');

        subwayScript.showSpinner();

        $.ajax({
            url: $reorderForm.attr("action"),
            type: "POST",
            data: $reorderForm.serialize(),
            success: function (data) {
                $('#lastOrderReOrderModal').hide();
                subwayScript.hideSpinner();
                if (data.Error) {
                    subwayScript.showAjaxError(data);
                } else if (!IsAddToBag) {
                    AddRecentOrderToCart(data, reOrderbtn = "reorder", false, mergeCart);
                } else {
                    orderViewModel.currentOrder.cartQuantity = (parseInt(orderViewModel.currentOrder.cartQuantity) + parseInt(data.currentOrder.orderQuantity));
                    if (fromOrderAgain) {
                        if (data.currentOrder && data.currentOrder.currentProudcts.length > 0) {
                            var categoryname =  data.currentOrder.currentProudcts[0].analyticsCategoryName 
                            var productname = data.currentOrder.currentProudcts[0].analyticsProductName 
                            var productId = data.currentOrder.currentProudcts[0].analyticsProductId
                            var categoryId = data.currentOrder.currentProudcts[0].analyticsCategoryId
                            orderViewModel.addAnalyticsCartProducts(categoryId, productId, categoryname, productname);
                        }                      
                    }
                    orderViewModel.save();
                    var addToBagSource = subwayScript.isDashboard()
                        ? analytics.addToBagSources.recentOrderHome
                        : analytics.addToBagSources.recentOrderSubPage;
                    if (fromOrderAgain) {
                        addToBagSource = analytics.addToBagSources.orderAgainSource;
                    }
                    var products = recentOrderItems ? recentOrderItems : data.currentOrder.currentProudcts;
                    const isCapitalResponse = recentOrderItems ? true : false;
                    var isAnalyticsInStock = data.currentOrder && data.currentOrder.currentProudcts && data.currentOrder.currentProudcts[0].analyticsInStock || "";
                    var filterProductArr = products.filter(itr => (itr.analyticsInStock || itr.inStock || isAnalyticsInStock)) || []
                    analytics.ReOrderCart(data.cartId);
                    analytics.RemoveItemAndCheckout("", filterProductArr, addToBagSource, reOrderbtn, "out of stock modal", data.currentItemResponse, fromOrderAgain, !isCapitalResponse);
                    analytics.cartOpen()
                    analytics.attemptTrack('addToBag');
                    localStorage.setItem('cartProgressBar', data.cartQuantity);
                    loadCartBag();
                    analytics.removalBannerAnalytics(AddToBagSuccessMsg);
                }
            },
            error: function (jqXhr) {
                $('#lastOrderReOrderModal').hide();
                subwayScript.hideSpinner();
                modalClose(true);
                subwayScript.showAjaxError(jqXhr);
            },
        });
    } else {
        subwayScript.showLocationRequiredModal();
        return;
    }
}

function AddRecentOrderToCart(data, reOrderbtn, isAddToBag, mergeCart, recentOrderItems) {
    orderViewModel.OrderSourceType = analytics.orderSourceType.recentOrderCart;
    analytics.OrderSourceType(orderViewModel.OrderSourceType);
    var addToBagSource = subwayScript.isDashboard()
        ? analytics.addToBagSources.recentOrderHome
        : analytics.addToBagSources.recentOrderSubPage;
    orderViewModel.currentOrder.itemAddedtoBag = 0;
    var products = recentOrderItems ? recentOrderItems : data.currentOrder.currentProudcts;
    var prodId;
    var productName;
    var categoryId;
    var categoryName;
    for (var i = 0; i < products.length; i++) {
        prodId = products[i].analyticsProductId;
        productName = products[i].analyticsProductName;
        categoryId = products[i].analyticsCategoryId;
        categoryName = products[i].analyticsCategoryName;
        orderViewModel.addAnalyticsCartProducts(categoryId, prodId, categoryName, productName)
        orderViewModel.save();
        if (products[i].options) {
            var options = [];
            for (var j = 0; j < products[i].options.length; j++) {
                if (products[i].options[j].available) {
                    options[j] = products[i].options[j];
                }
            }
            products[i].options = options;
        }
    }
    var currentCartItemResponse = data && data.cartItemResponse;
    var cartItemId;
    var masterProductId;
    if (currentCartItemResponse) {
      for (var i = 0; i < currentCartItemResponse.length; i++) {
        cartItemId = currentCartItemResponse[i].cartItemId;
        prodId = currentCartItemResponse[i].productId;
        masterProductId = currentCartItemResponse[i].masterProductId;
        orderViewModel.addCartProducts(cartItemId, prodId, "", "");
        orderViewModel.save();
      }
    }

    var filterProductArr = products && products.filter(itr => {
        const flag = itr.analyticsInStock ? (itr.analyticsInStock.toString().toLowerCase() == "true") : true;
        return  flag
    }) || []

    if (data.currentOrder !== null && currentStore !== data.currentOrder.storeId && !mergeCart) {
        const storeNumber = data.currentOrder.storeId ? data.currentOrder.storeId.split('-') : []
        orderViewModel.store.storeNumber = storeNumber.length > 0 ? storeNumber[0] : '';
        orderViewModel.store.satelliteNumber = storeNumber.length > 1 ? storeNumber[1] : '';
        orderViewModel.store.id = subwayScript.checkSatelliteNumber(data.currentOrder.storeId);
        orderViewModel.store.address = data.currentOrder.storeAddress;
        orderViewModel.store.storeCountry = data.currentOrder.countryCode;
        if (data.currentOrder.store !== null) {
            orderViewModel.store.address1 = data.currentOrder.store.locationAddress1;
            orderViewModel.store.address3 = data.currentOrder.store.locationAddress3;
            orderViewModel.store.stateProvCode = data.currentOrder.store.locationStateProv;
            orderViewModel.store.city = data.currentOrder.store.locationCity;
            orderViewModel.store.zip = data.currentOrder.store.locationZipCode;
            orderViewModel.store.postalCode = data.currentOrder.store.locationZipCode;
            orderViewModel.store.phoneNumber = data.currentOrder.store.phoneNumber;
        }
    }
    let quantity = 0
    orderViewModel.currentOrder.itemAddedtoBag = 0;
    orderViewModel.currentOrder.cartId = data.cartId;
    orderViewModel.IsSidesOrDrinksLimitReached = data.isSidesOrDrinksLimitReached;
    data.cartItemResponse && data.cartItemResponse.forEach(item => quantity += item.Quantity);
    orderViewModel.currentOrder.cartQuantity = quantity
    orderViewModel.save();
    if (reOrderbtn) {
        analytics.ReOrderCart(data.cartId);
        analytics.RemoveItemAndCheckout("", filterProductArr, addToBagSource, reOrderbtn, null, data.currentItemResponse,true);
        analytics.cartOpen()
        analytics.attemptTrack('addToBag');
    }

    if (isAddToBag) {
        $("#lastOrderReOrderModal").hide()
    } else {
        if (mergeCart) {
            $("#lastOrderReOrderModal").hide();
            loadCartBag();
            getBannerMessage('success', AddToBagSuccessMsg);
            analytics.removalBannerAnalytics(AddToBagSuccessMsg);
        } else {
            window.location.href = data.successUrl;
        }
    }
}

function lastorderReorderModal(el, recentOrdersCartId, reOrderbtn, recentOrderItems) {
    if (el) {
        var buttonText = $(el).text().trim();
        orderViewModel.OrderSourceType = analytics.orderSourceType.recentOrderCart;
        analytics.lastorderReorder(buttonText, orderViewModel.OrderSourceType);
        var order = $(el).closest(".lo-order-cart");
        var productAvailable = false;
        var itemAvailable = false;
        var cartId = order.data("cartid");
    } else {
        var productAvailable = false;
        var itemAvailable = false;
        var cartId = recentOrdersCartId;
    }
    if (productAvailable == true && itemAvailable == true) {
        return AddlastordertoCart(cartId, true, reOrderbtn);
    } else {
        modalClose();
        $("#initModal").attr("value", "true");
        return loadlastorderReorderModal(cartId, true, reOrderbtn, recentOrderItems);
    }
};

function loadlastorderReorderModal(cartId, isRecentOrders, reOrderbtn, recentOrderItems) {
    subwayScript.showSpinner();
    var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
    $("#OrderHistoryItemStoreId").val(currentStore);
    $("#OrderHistoryItemCartId").val(cartId);
    if (Number(orderViewModel.currentOrder.cartQuantity) > 0) {
        $("#OrderHistoryItemMergeCart").val(true);
    }
    $("#OrderHistoryItemOrderId").val(orderViewModel.currentOrder.cartId);
    var $form = $("#frmOrderHistoryItem");
    var formStoreID = $("#OrderHistoryItemStoreId", $form).val();
    if (formStoreID == 0) {
        $("#OrderHistoryItemStoreId", $form).val(formStoreID);
    }
    if (isRecentOrders) {
        $('#hdnIsRecentOrder', $form).val(true);
    }
    $("#hdnAccordionOpen", $form).val(false);
    $.ajax({
        url: $form[0].action,
        type: "POST",
        data: $form.serialize(),
        error: function (jqXhr) {
            subwayScript.hideSpinner();
            subwayScript.showAjaxError(jqXhr);
        },
        success: function (htmlString) {
            subwayScript.hideSpinner();
            var productAvailable = htmlString.itemavailable;
            var ingredientsAvailable = htmlString.ingredientavailable;
            if (productAvailable == true && ingredientsAvailable == true) {
                return AddlastordertoCart(cartId, true, reOrderbtn, recentOrderItems);
            } else {
                LastOrderAndRecentOrderPopup(cartId, reOrderbtn, null, null, recentOrderItems);
            }
        }
    });
}

function LastOrderAndRecentOrderPopup(cartId, reOrderbtn, productID, paylaod, analyticsProductArr = []) {
    var IsAddToBag = false;
    if (reOrderbtn === "ADD TO BAG") {
        IsAddToBag = true;
    }
    var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
    $("#OrderHistoryItemStoreId").val(currentStore);
    $("#OrderHistoryItemCartId").val(cartId);
    var $form = $("#frmOrderHistoryItem");
    var formStoreID = $("#OrderHistoryItemStoreId", $form).val();
    if (formStoreID == 0) {
        $("#OrderHistoryItemStoreId", $form).val(formStoreID);
    }
    $('#hdnIsRecentOrder', $form).val(false);
    $("#hdnAccordionOpen", $form).val(false);
    subwayScript.showSpinner();
    $.ajax({
        url: $form[0].action,
        type: "POST",
        data: $form.serialize() + "&IsAddToBag=" + IsAddToBag + "&ProductId=" + productID,
        beforeSend: function () {
            subwayScript.showSpinner();
        },
        error: function (jqXhr) {
            subwayScript.showAjaxError(jqXhr);
        },
        success: function (htmlString) {
            var data = htmlString;
            //bind the all html data in the '$orderModal' model
            var $orderModal = $("#lastOrderModal");
            $orderModal.html(data);
            $('#lastOrderModal').attr('aria-hidden', 'false');
            $('.reordermodal-overlay').attr('aria-hidden', 'false');
            if (reOrderbtn == "ADD TO BAG") {
                $('#lastOrderReOrderModal').addClass('addtocart-error-modal');
                $("#lastOrderReOrderModal").attr("data-current-item-selected", JSON.stringify(paylaod));
                $("#lastOrderReOrderModal").attr("data-current-item-analytics-arr", JSON.stringify(analyticsProductArr));
            } else {
                $('#lastOrderReOrderModal').removeClass('addtocart-error-modal');
                $("#lastOrderReOrderModal").attr("data-current-item-selected", null);
                $("#lastOrderReOrderModal").attr("data-current-item-analytics-arr", null);
            }
            if (Number(orderViewModel.currentOrder.cartQuantity) > 0) {
                $('#MergeCartHide').hide();
                $('#MergeCartShow').show();
            }
            analyticsProductArr ? showLastOrderReOrderErrorModal(analyticsProductArr) : showLastOrderReOrderErrorModal();
            if ($('#lastOrderReOrderModal .prd-items').text().trim() === "Product unavailable" || "Produit non disponible") {
                analytics.lastOrderReOrderPopupModalPageView();
                setTimeout(() => {
                    analytics.lastOrderReOrderPopup($('#lastOrderReOrderModal .prd-items').text().trim())
                }, 300);
            } else {
                analytics.lastOrderReOrderPopupModalPageView();
                setTimeout(() => {
                    analytics.lastOrderReOrderPopup($('#lastOrderReOrderModal .item-head-txt').text().trim())
                }, 300);
            }
        },
        complete: function (result) {
            subwayScript.hideSpinner();
        }
    });
}

function AddlastordertoCart(cartId, skipStoreRequired, reOrderbtn, recentOrderItems, event=null) {
    if(event){
        applyDancingBubble(event, 'white', true);
    }
    var currentStore = (orderViewModel.store && orderViewModel.store.id) || 0;
    var isAddToBag = $("#lastOrderReOrderModal").hasClass("addtocart-error-modal");
    var paylaod = $('#lastOrderReOrderModal').attr('data-current-item-selected') ? JSON.parse($('#lastOrderReOrderModal').attr('data-current-item-selected')) : [];
    var optionsItem = $('#productNameGetOpt').attr('data-item-options') ? JSON.parse($('#productNameGetOpt').attr('data-item-options')) : [];
    var comboItems = $('#productNameGetOpt').attr('data-item-miam') ? JSON.parse($('#productNameGetOpt').attr('data-item-miam')) : [];
    var optionUnAvailableFilter = optionsItem.filter(i => i.available);
    var miamUnAvailableFilter = comboItems.items && comboItems.items.filter(i => i.IsComboItemAvailale);

    var mergeCart = false;
    if (Number(orderViewModel.currentOrder.cartQuantity) > 0) {
        mergeCart = true;
        mergeCartID = orderViewModel.currentOrder.cartId;
    }

    if (isCurrentPage("home")) {
        analytics.removeAndContinue(reOrderbtn);
    }

    if (isAddToBag && paylaod) {
        paylaod.items.AddCartItems[0].options = optionUnAvailableFilter;
        recentOrderItems[0].Options = optionUnAvailableFilter;
        if (miamUnAvailableFilter) {
            paylaod.items.AddCartItems[0].combo.ComboItems = miamUnAvailableFilter;
        }
        ReOrderCart(cartId, true, isAddToBag, paylaod.items.AddCartItems[0].productId, orderType = '', reOrderbtn, recentOrderItems, paylaod.isOrderAgain);
        const analyticsProductArr = $('#lastOrderReOrderModal').attr('data-current-item-analytics-arr') ? JSON.parse($('#lastOrderReOrderModal').attr('data-current-item-analytics-arr')) : []
        return;
    }

    if (
        orderViewModel.store.id != null &&
        orderViewModel.currentOrder.cartQuantity != 0 &&
        $("#reorder-change-store").attr("aria-hidden") != "false" && !isAddToBag && !mergeCart
    ) {
        if ($("#orderDetails").attr("aria-hidden") != "true") {
            $("#orderDetails").hide();
        }

        const errMsg = $('#reorder-change-store .error-body').text() || ''
        analytics.errorMessage(errMsg, 'n/a', 'n/a', false)

        $("#btnReorderItem").on("click keypress", function (e) {
            AddlastordertoCart(cartId, true, reOrderbtn, recentOrderItems);

        });
        return;
    }
    if (skipStoreRequired === true || (orderViewModel.store && orderViewModel.store.id)) {
        subwayScript.showSpinner();
        var $reorderForm = $("#frmReorderCart");
        if (cartId !== "") {
            $('[name="CartId"]', $reorderForm).val(cartId);
            $('[name="OrderId"]', $reorderForm).val(orderViewModel.currentOrder.cartId);

        }
        if ($("#optionalAddress").val()) {
            orderViewModel.DeliveryAddress.StreetAddressLine2 = $("#optionalAddress").val();
            orderViewModel.save();
        }
        if (!isAddToBag) {
            $('[name="OrderId"]', $reorderForm).val('');
            $('[name="CurrentCartId"]', $reorderForm).val('');
        }
        if (mergeCart) {
            $('[name="MergeCart"]', $reorderForm).val(true);
            $('[name="MergeCartId"]', $reorderForm).val(mergeCartID);
        }
        $('[name="IsAddToBag"]', $reorderForm).val(isAddToBag);
        $('[name="StoreId"]', $reorderForm).val(currentStore);
        $('[name="StreetAddressLine1"]', $reorderForm).val(orderViewModel.DeliveryAddress.StreetAddressLine1);
        $('[name="StreetAddressLine2"]', $reorderForm).val(orderViewModel.DeliveryAddress.StreetAddressLine2);
        $('[name="City"]', $reorderForm).val(orderViewModel.DeliveryAddress.City);
        $('[name="State"]', $reorderForm).val(orderViewModel.DeliveryAddress.State);
        $('[name="Zip"]', $reorderForm).val(orderViewModel.DeliveryAddress.Zip);
        $('[name="Country"]', $reorderForm).val(orderViewModel.DeliveryAddress.Country);
        $('[name="DirectDelivery"]', $reorderForm).val(orderViewModel.DeliveryAddress.DirectDelivery);
        $('[name="QuoteId"]', $reorderForm).val(orderViewModel.DeliveryAddress.QuoteId);
        $('[name="OrderType"]', $reorderForm).val(orderViewModel.orderType);
        $('[name="OrderSourceType"]', $reorderForm).val(analytics.orderSourceType.recentOrderCart);

        $.ajax({
            url: $reorderForm.attr("action"),
            type: "POST",
            data: $reorderForm.serialize(),
            success: function (data) {
                $('#lastOrderReOrderModal').hide();
                if (data.Error) {
                    subwayScript.showAjaxError(data);
                } else if (!data.isWebOrderAvailable) {
                    modalShowId("#modal-web-order-not-available");
                } else if (!data.isStoreOpen) {
                    modalShowId("#modal-store-closed");
                } else {
                    AddRecentOrderToCart(data, reOrderbtn, isAddToBag, mergeCart, recentOrderItems);
                }
            },
            error: function (jqXhr) {
                $('#lastOrderReOrderModal').hide();
                subwayScript.hideSpinner();
                modalClose(true);
                subwayScript.showAjaxError(jqXhr);
            }
        });
    } else {
        subwayScript.showLocationRequiredModal();
        return;
    }
}

function orderStatusRedirect() {
    var $form = $("#frmDeliveryOrderETA");
    subwayScript.showSpinner();
    $.ajax({
        url: $form[0].action,
        type: "POST",
        dataType: "json",
        error: function (jqXhr) {

        },
        success: function (result) {
            var redirectUrl = subwayScript.navigation.getDeliveryStatusUrl(result.CartId);
            window.location.href = redirectUrl;
        },
        complete: function (result) {
            subwayScript.hideSpinner();
        }
    });
}

$(document).on('click', '.order-status', function () {
    orderViewModel.orderStatusClicked = true;
    orderViewModel.save();
    var buttonText = $(this).text().trim();
    analytics.cardListClick(buttonText);
    var cartId = $(this).data("cartid");
    var orderType = $(this).data("ordertype");
    var redirectUrl = "";
    if (orderType.toLowerCase() === "delivery") {
        redirectUrl = subwayScript.navigation.getDeliveryStatusUrl(cartId);
    } else {
        redirectUrl = subwayScript.navigation.getOrderConfirmationPageUrl(cartId);
    }
    window.location.href = redirectUrl;
});

function addToCartLineItems(itemId, cartId, productId, productName, orderFulFillmentType, categoryId, categoryName, price, isOrderAgain, productNameWithoutSize = '', inStock , quantity = 1, isCookie,masterProductId=null,subCategory = null, size = null,isSoup = false) {
    const getOptions = $('#' + itemId).attr('data-item-options') || [];
    const isKidsMeal = ($('#' + itemId).attr('data-iskidsmeal') ==='True') || false;
    if (!isOrderAgain) productNameWithoutSize = $('.' + itemId).attr('data-analytics-product-id') || '';

    const out_of_stock_price = getOptions.length ? parseFloat(getOutOfStockItemsPrice(JSON.parse(getOptions))) : 0;
    const getCombo = $('#' + itemId).attr('data-item-miam');
    const selectedStoreId = orderViewModel.store.id;
    orderViewModel.reOrderbtn = 'ADD TO BAG';
    orderViewModel.RecentOrderCartID = cartId;
    orderViewModel.recentOrderProductID = productId;
    isOrderAgain ? orderViewModel.IsOrderAgainAddToCart = true
        : orderViewModel.IsRecentOrderAddToCart = true;

    orderViewModel.OrderSourceType = analytics.orderSourceType.recentOrderCart ;
    price = price/quantity;
   
    orderViewModel.save();
    if (isOrderAgain) {
        analytics.orderAgainCLickAction();
    }
    let analyticsProductArr = []
    analyticsProductArr.push({
        AnalyticsCategoryName: categoryName,
        AnalyticsCategoryId: categoryId,
        AnalyticsProductName: productNameWithoutSize,
        ProductNameWithSize: productName,
        AnalyticsProductId: productId,
        InStock: inStock,
        Quantity: 1,
        Price: price - out_of_stock_price,
        Combo: null,
        Options:null
    })
    const paylaod = {
        "items": {
            "AddCartItems": [
                {
                    "analytics" : {
                        "CategoryId" : categoryId,
                        "CategoryName": categoryName,
                        "ProductName": productNameWithoutSize,
                        "IsCookie" : isCookie,
                        "masterProductId":masterProductId,
                        "subCategory" : subCategory,
                        "size": size,
                        "isSoup":isSoup,
                    },
                    "options": getOptions.length > 0 ? JSON.parse(getOptions) : getOptions,
                    "productId": productId,
                    "productName": productName,
                    "quantity": 1,
                    "imageUrl": "/ns/images/Menu/USA/ENG/Category_767x767_BlackForestHam_Sandwiches_@1x.jpg"
                }
            ]
        },
        "StoreId": orderViewModel.store.StoreId,
        "LocationId": orderViewModel.store.StoreId,
        "CartId": orderViewModel.currentOrder.cartId,
        "IsKidsMeal":isKidsMeal,
        "pricingScheme": "1",
        "fulfillmentType": orderViewModel.orderType ? orderViewModel.orderType : "pickup",
        "dineIn": false,
        "curbside": {
            "curbsideInstructions": " "
        },
        "orderInstructions": " ",
        "siteName": $('#hdnSiteName').val()
    };

    if (getCombo) {
        var combos = JSON.parse(getCombo)
        if (combos.comboName || combos.ComboName) {
            paylaod.items.AddCartItems[0].combo = combos
            const combo_items = paylaod.items.AddCartItems[0].combo.items || paylaod.items.AddCartItems[0].combo.Items;
            paylaod.items.AddCartItems[0].combo.ComboItems = combo_items;
            analyticsProductArr[0].Combo = combos;
            analyticsProductArr[0].Combo.ComboItems = combo_items;
        }
    };
    getOptions.length > 0 ? analyticsProductArr[0].Options = JSON.parse(getOptions) :
        analyticsProductArr[0].Options = getOptions;
    if (!selectedStoreId || !orderViewModel.currentOrder.cartId) {
        orderViewModel.addToBagLineItem = true;
        orderViewModel.addToBagPayLoadItem = {
            "paylaod": paylaod,
            "analyticsProductArr": analyticsProductArr
        };
        orderViewModel.save();
        if (isOrderAgain) {
            analytics.orderAgainFailClickAction();
        } 
        window.location.href = subwayScript.navigation.getLocatorUrl();

    } else {
        orderViewModel.addToBagPayLoadItem = null;
        orderViewModel.save();
    }
    
    StoreValidationAsync(cartId, productId, paylaod, analyticsProductArr, isOrderAgain);
}

function StoreValidationAsync(cartId, productId, paylaod, analyticsProductArr, isOrderAgain) {
    var mergeCart = true;
    let element =  document.querySelector(".product-wrapper.blur");
    
    var data = {
        CartId: cartId,
        StoreId: orderViewModel.store.id,
        OrderType: orderViewModel.orderType,
        MergeCart: mergeCart,
        SiteName: $('#hdnSiteName').val()
    };

    if (orderViewModel.orderType == 'delivery' || orderViewModel.orderType == 'Delivery') {
        data = {
                CartId: cartId,
                StoreId: orderViewModel.store.id,
                OrderType: orderViewModel.orderType,
                MergeCart: mergeCart,
                SiteName: $('#hdnSiteName').val(),
                StreetAddressLine1: orderViewModel.DeliveryAddress.StreetAddressLine1,
                StreetAddressLine2: '',
                City: orderViewModel.DeliveryAddress.City,
                State: orderViewModel.DeliveryAddress.State,
                Zip: orderViewModel.DeliveryAddress.Zip,
                Country: orderViewModel.DeliveryAddress.Country,
        }
    }

    $.ajax({
        url: '/RemoteOrder/Orders/OrderHistoryStoreValidationAsync',
        type: 'POST',
        cache: false,
        headers: { "cache-control": "no-cache" },
        data: data,
        error: function (jqXhr) {
            removeDancingBubble(null);
            element? element.classList.remove("blur") : null ;
            if (jqXhr.responseJSON && (jqXhr.responseJSON.Error.ErrorCode.toLowerCase() == 'dord-3006' || jqXhr.responseJSON.Error.ErrorCode.toLowerCase() == 'ordr-3000')) {
                modalShowId('#modal-store-closed');
                const warning = $('#modal-store-closed .body-txt').text() || ''
                analytics.storeCloseModalAnalytics('select a new restaurant modal')
                analytics.storeCloseFavoriteWarning(warning)
            } else {
                subwayScript.showAjaxError(jqXhr);
            }
            subwayScript.hideSpinner();
        },
        success: function (data) {
            if (data.Error) {
                subwayScript.showAjaxError(data);
            } else if (!data.IsStoreOpen && data.IsStoreOpen!==undefined) {
                removeDancingBubble(null);
                element? element.classList.remove("blur") : null ;
                modalShowId("#modal-store-closed");
                const warning = $('#modal-store-closed .body-txt').text() || ''
                analytics.storeCloseModalAnalytics('select a new restaurant modal')
                analytics.storeCloseFavoriteWarning(warning)
            } else {
                AddItemAsync(cartId, productId, paylaod, analyticsProductArr, isOrderAgain);
            }            
        }
    });
}

function AddItemAsync(cartId, productId, paylaod, analyticsProductArr, isOrderAgain) {
    subwayScript.showSpinner();
    let element =  document.querySelector(".product-wrapper.blur");
    paylaod.fulfillmentType = orderViewModel.orderType;
    paylaod.items.AddCartItems[0].analytics.ProductOriginSource = analytics.orderSourceType.recentOrderCart;
    paylaod.items.AddCartItems[0].analytics.ComboOriginSource = getComboOriginSource(paylaod, isOrderAgain, analytics);
    paylaod.siteName = $('#hdnSiteName').val(); //sitename for new culture
    paylaod.IsReactResponse = false; 
    if (isOrderAgain) {
        paylaod.isOrderAgain = true;
    }
    $.ajax({
        url: '/RemoteOrder/Orders/AddItemAsync',
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(paylaod),
        beforeSend: function () {
            subwayScript.showSpinner();
        },
        success: function (response) {
            subwayScript.hideSpinner();
            removeDancingBubble(null);
            element? element.classList.remove("blur") : null ;
            orderViewModel.currentOrder.cartQuantity = response.CartQuantity;
            orderViewModel.addAnalyticsCartProducts(response.CategoryId, response.CartCurrentItem.ProductId, response.CartCurrentItem.Analytics.CategoryName, response.CartCurrentItem.Analytics.ProductName);
            orderViewModel.save();
            analytics.OrderSourceType(orderViewModel.OrderSourceType);
            analytics.ReOrderCart(response.CartId);
            var addToBagSource = subwayScript.isDashboard()
                ? analytics.addToBagSources.recentOrderHome
                : analytics.addToBagSources.recentOrderSubPage;
            var cartCurrentItem = [response.CartCurrentItem];
            if (isOrderAgain) {
                addToBagSource = analytics.addToBagSources.orderAgainSource;
                analyticsProductArr[0].AnalyticsCategoryName = response.CartCurrentItem.Analytics && response.CartCurrentItem.Analytics.CategoryName;
                analyticsProductArr[0].Price = cartCurrentItem[0].UnitPrice;
                analyticsProductArr[0].AnalyticsProductId = cartCurrentItem[0].ProductId;
            }
            analytics.RemoveItemAndCheckout("", analyticsProductArr, addToBagSource, isOrderAgain ? 're-order' : 'add to cart', null, cartCurrentItem, isOrderAgain, false);
            analytics.cartOpen()
            analytics.attemptTrack('addToBag');
            localStorage.setItem('cartProgressBar', response.CartQuantity);
            subwayScript.hideSpinner();
            if (orderViewModel.currentOrder.cartQuantity > 0) {
                loadCartBag();
            }
            analytics.removalBannerAnalytics(AddToBagSuccessMsg);
        },
        error: function (error) {
            modalClose();
            removeDancingBubble(null);
            element? element.classList.remove("blur") : null ;
            $("#initModal").attr("value", "true");
            if (error.responseJSON.Error && error.responseJSON.Error.ErrorCode.toLowerCase() === "dord-3004") {
                LastOrderAndRecentOrderPopup(cartId, 'ADD TO BAG', productId, paylaod, analyticsProductArr);
            }
            if (error.responseJSON.Error && (error.responseJSON.Error.ErrorCode.toLowerCase() === "dord-9991" || error.responseJSON.Error.ErrorCode.toLowerCase() === "dord-3007" || error.responseJSON.Error.ErrorCode.toLowerCase() === "dord-3030")) {
                $('#modal-error #error-title').text(error.responseJSON.Error.Title);
                $('#modal-error #error-body').text(error.responseJSON.Error.Message);
                modalShowId('#modal-error');
            }
            if (error.responseJSON.Error && (error.responseJSON.Error.ErrorCode.toLowerCase() === "ordr-3000" || error.responseJSON.Error.ErrorCode.toLowerCase() == 'dord-3006')) {
                modalShowId('#modal-store-closed');
            }
        },
        complete: function () {
            orderViewModel.addToBagPayLoadItem = null;
            orderViewModel.save();
        }
    });
}

$(document).on('click', '.keepshopping-addtobag', function (event) {
    applyDancingBubble(event, 'green', true)
    var attemptTrack = isCurrentPage('home') ? 'dashboard_click_action' : 'recent_order_click_action';
    var buttontext = $('#MergeCartShow').val();
    analytics.keepShopping(buttontext, true, attemptTrack);
    setTimeout(() => {
        window.location.href = subwayScript.navigation.getMenuUrl(orderViewModel.store.id);
    }, 1000);
});


const filterProductName = product_name => {
    if(sizeNames.length) {
        const size_substrings = sizeNames.filter((size) => 
        product_name.toLowerCase().includes(size));
        if(size_substrings.length) {
            const longest_size_string = size_substrings.reduce(
                function (a, b) {
                    return a.length > b.length ? a : b;
                }
            );
        const longest_size_string_regex = new RegExp(longest_size_string, "ig");
        product_name = product_name.replace(longest_size_string_regex,"").trim();
      }
    }
    return product_name;
};
function getComboOriginSource(paylaod, isOrderAgain, analytics) {
  if (paylaod.items.AddCartItems[0].combo && Object.keys(paylaod.items.AddCartItems[0].combo).length !== 0 && isOrderAgain) {
    return analytics.orderSourceType.reorder;
  }
  return "n/a";
}